define("ember-svg-jar/inlined/trial-reels", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<g clip-path=\"url(#clip0_652_12789)\" fill=\"#64727C\"><path d=\"M4.572 24.253A5.466 5.466 0 008 25.451h5.143v2.5H8l-.412-.01a7.96 7.96 0 01-4.575-1.737l1.56-1.95zm20.414 1.951a7.959 7.959 0 01-4.574 1.737l-.412.01h-5.143v-2.5H20c1.3 0 2.487-.447 3.428-1.198l1.558 1.951zM2.5 19.951c0 1.3.447 2.488 1.198 3.428l-1.952 1.559a7.961 7.961 0 01-1.735-4.574L0 19.95V14.81h2.5v5.143zm25.5 0a7.964 7.964 0 01-1.747 4.987l-1.951-1.559a5.468 5.468 0 001.198-3.428V14.81H28v5.143zM2.5 13.095H0V8.682h2.5v4.412zm25.5 0h-2.5V8.682h.5c.69 0 1.36-.087 2-.252v4.664z\"/><path d=\"M20 0a8 8 0 018 8v.7H0V8a8 8 0 018-8h12zM7.06 2.59A5.49 5.49 0 002.8 6.23h6.44L7.06 2.59zm2.86-.09l2.28 3.73h5.25L15.22 2.5h-5.3zm8.22 0l2.22 3.73h4.84A5.501 5.501 0 0020 2.5h-1.86zM18.16 15.825L12 12.245a1.12 1.12 0 00-1.67 1.01v7.19a1.13 1.13 0 001.67 1l6.16-3.62a1.19 1.19 0 000-2z\"/></g><defs><clipPath id=\"clip0_652_12789\"><path fill=\"#fff\" d=\"M0 0h28v28H0z\"/></clipPath></defs>",
    "attrs": {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 28 28",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  };
});